import React from "react";
import YellowDivider from "../../components/dividers/YellowDivider";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import NewsCatalogue from "../../components/catalogue/news/NewsCatalogue";

const NewsCataloguePage: React.FC = () => {
  const { t, ready } = useTranslation();
  return (
    <div className="main cafe-page">
      <div className="container pt-4">
        <div className="mb-md-0 mb-lg-3">
          <h2>
            {" "}
            {ready ? (
              `${t("catalogue-filter.news-catalogue")}`
            ) : (
              <Skeleton width={200} />
            )}
          </h2>
          <YellowDivider heading="h1" />
          <NewsCatalogue />
        </div>
      </div>
    </div>
  );
};

export default NewsCataloguePage;
